import React, { useState } from 'react';
import Modal from '@andes/modal';
import StyledLabel from '../styled-label';
import VPCItems from './items';
import { PT_INFOMODAL, DF_INFOMODAL } from './proptypes';

const namespace = 'ui-pdp-vpc-modal';

const InfoModal = ({ title, subtitle, action, items, type }) => {
  const [open, setOpen] = useState(false);
  const onOpen = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className={`${namespace}__container`} data-testid="info-modal">
      <StyledLabel as="a" className={`${namespace}__action`} onClick={onOpen} text={action.display_text} />
      <Modal className={namespace} open={open} onClose={onClose} maxWidth={480} title={title.text} type={type}>
        <>
          <StyledLabel as="p" className={`${namespace}__subtitle`} {...subtitle} />
          <VPCItems namespace={namespace} items={items} />
        </>
      </Modal>
    </div>
  );
};

InfoModal.displayName = 'InfoModal';

InfoModal.propTypes = PT_INFOMODAL;

InfoModal.defaultProps = { ...DF_INFOMODAL };

export default React.memo(InfoModal);
